__turbopack_context__.v({
  "campaignWrapper": "ProductBasedCTA-module-scss-module__xEh2Pa__campaignWrapper",
  "title": "ProductBasedCTA-module-scss-module__xEh2Pa__title",
});
